import React, { Fragment } from "react";
import { motion } from "framer-motion";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import AboutTab from "./AboutTab";
import FunFactSection from "../../components/FunFact/FunFact";
import PartnerSection from "../../components/PartnerSection";
import Mcc from "../../components/mcc/Mcc";
// import BgImage from "../../images/bg/bg-1.png";
// import FeaturesSection3 from "../../components/FeaturesSection3/FeaturesSection3";

const TaniltsuulgaPage = ({ isDark, onToggleDark }) => {
  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main about-page">
          <PageTitle
            pageTitle={"Бидний танилцуулга"}
            pagesub={"Танилцуулга"}
            tolink={"#tanil"}
          />
          <section className="about pt-80 pb-10" id="tanil">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="sectionTitle text-center mb-30">
                    <Mcc />
                    <h2 className="sectionTitle__big">
                      Бид эрүүл, аюулгүй орчныг <br /> эрхэмлэн ажиллаж байна
                    </h2>
                  </div>
                </div>
                <div className="col-lg-10 mx-auto">
                  <div className="aboutDetails text-center">
                    <p className="aboutDetailsText mb-20">
                      Бид эрүүл, аюулгүй ажиллагааг эрхэмлэн ажиллахдаа{" "}
                      <strong>
                        ХҮНДЭТГЭЛ, ХАРИУЦЛАГА, ЁС ЗҮЙ, ХАМТЫН ЗҮТГЭЛ{" "}
                      </strong>
                      гэсэн үнэт зүйлсийг мөрддөг. <br />
                      Бид бусадтай <strong>ХҮНДЭТГЭЛТЭЙ</strong> хандаж, бие
                      биеэ хайрлан, эрүүл мэнд, аюулгүй ажиллагаа, сайн сайхан
                      амьдралд нь санаа тавин тогтвортой хөгжлийг ямагт дэмжин
                      ажиллана.
                    </p>
                    <p className="aboutDetailsText mb-20">
                      Бид ямар ч ажлыг <strong>ЁС ЗҮЙТЭЙ</strong> гүйцэтгэдэг.
                      Аливаа ажлыг ёс журмын дагуу, үнэнч шударгаар гүйцэтгэх нь
                      бидний амжилтын үндэс юм. <br />
                      <strong>ХАМТЫН ЗҮТГЭЛ</strong> нь бид нэг нэгэнтэйгээ
                      хамтран ажилласнаар хамгийн сайн үр дүн, ололт амжилтад
                      хүрдэг гэдгийг илтгэнэ.
                      <br />
                      Бид аливаа үйлдэл, шийдвэр, гарах үр дагавар бүхэндээ
                      <strong> ХАРИУЦЛАГАТАЙ</strong> ханддаг.
                    </p>
                    <p className="aboutDetailsText mb-20">
                      Бид Монгол улсын холбогдох хууль тогтоомж стандарт, дүрэм
                      журмын хүрээнд хүнсний аюулгүй байдал, барилга байгууламж,
                      хөдөлмөр хамгаалал техникийн аюулгүй ажиллагаа, галын
                      аюулгүй ажиллагаа, технологи, ариун цэвэр, эрүүл ахуйн
                      үндсэн шаардлагыг <strong>MNS CAC/RCP 39-2011</strong>{" "}
                      стандартын дагуу мөрдөн өдөр тутмын үйл ажиллагаагаа
                      явуулж байна.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <AboutTab />
          {/* <FeaturesSection3 /> */}
          <FunFactSection />

          {/* <PartnerSection /> */}
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default TaniltsuulgaPage;
